module.exports = __webpack_public_path__ + "media/images/map-icons/mapbox-street-e05273ef2cfabb46a316f58d16c6f3f4.png";